import React from 'react';
import './Advertising.css';

const Advertising = () => {
    return (
        <div >

            <div className="parent mb-5 mt-3">

              <div className="d-flex text-center justify-content-center align-items-center h-100">
             <div>
             <h3 style={{fontFamily:'cursive'}} className="text-white">Learning is a strong reason why people love to travel...</h3> <button className="btn btn-outline-primary m-3">Let's Travel</button> <button className="btn btn-outline-primary m-3">View More</button>
             </div>
              </div>

            </div>
            
        </div>
    );
};

export default Advertising;